import React, { useState, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import './SidePanel.css';

function SidePanel(props){

    const [ isOpen, setIsOpen ] = useState(true);
    const [ contentIsVisible, setContentIsVisible ] = useState(true);
    const [ menuOpen, setMenuOpen ] = useState(false);

    const panel = useRef(null);

    function openPanel(){
        setContentIsVisible( true );
        setIsOpen( true );
    }

    function closePanel(){
        setIsOpen( false );
        // let delay = Number( panel.current.style.transitionDuration.replace('s','') ) * 1200;
        setTimeout(() => {
            setContentIsVisible( false );
        }, 200); //delay is slightly shorter than the transition duration specified in the css
    }

    const {
        options,
        setSidePanel
    } = props;

    const listItems = useMemo(() =>{
		return (
			options.map((option, i) =>{
				return(
					<li
						onClick={
							(event) => {
								setSidePanel(event);
								setMenuOpen(false);
							} 
						}
						className="side_panel_option"
						// role="option"
						key={ i }
					>
						{ option }
					</li>
				);
			})
		);
	}, [ options, setSidePanel ]);

    const handleContainerBlur = event =>{
		if ( !event.currentTarget.contains( event.relatedTarget ) ){
			setMenuOpen(false);
		}
	};

    const listClass = (menuOpen && props.options.length > 1) ? "side_panel_list" : "display_none";

    return (
        <div id="side_panel" ref={ panel } className={ isOpen ? "side_panel panel_open" : "side_panel" }>
            <div id="side_panel_header" className={ contentIsVisible ? "panel_open" : "" }>
            {
                contentIsVisible ?
                    <>
                        <div 
                            id="side_panel_title_wrapper"
                            tabIndex="0"
                            onClick={ ()=>{
                                if( props.options.length > 1 ){
                                    setMenuOpen(menuOpen ? false : true);
                                }
                            } }
                            onBlur={ (e) => handleContainerBlur(e) }
                        >
                            <h3 id="side_panel_title">
                                { props.title }
                                {
                                    props.options.length > 1 &&
                                    <span className="side_panel_caret_span"
                                        tabIndex="-1"
                                        role="button"
                                        // aria-label="Show product desciptions"
                                        // onClick={ () => setHasFocus( (disabled ? false : !hasFocus) ) }
                                    >
                                        <Caret />
                                    </span>
                                }
                            </h3>
                            <div className="search_list_container">
                                <ul
                                    className={ listClass }
                                    // role="listbox"
                                    tabIndex="-1"
                                >
                                    { listItems }
                                </ul>
                            </div>
                        </div>
                        <div id="side_panel_collapse_button" onClick={ closePanel }>
                            <SideArrow />
                        </div>
                    </>
                    :
                    <div id="side_panel_open_button" onClick={ openPanel }>
                        <Hamburger />
                    </div> 
            }
            </div>
            <div id="side_panel_content" className={ contentIsVisible ? "visible" : "hidden" }>
                { props.children }
            </div>
        </div>
    );
}

function SideArrow(props){
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
          
            fill="#1965A3"
            className="side_panel_arrow"
            viewBox="0 0 13 13"
        >
            <path
                fillRule="evenodd"
                d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"
            />
        </svg>
    );
}

function Hamburger(props){
    return (
        <svg xmlns="http://www.w3.org/2000/svg"  width="22" height="22" viewBox="0 0 22 22">
            <defs>
                <clipPath id="clipPath">
                    <rect id="Rectangle_264" data-name="Rectangle 264" width="22" height="22" transform="translate(1156 658)" fill="#fff" stroke="#fff" strokeWidth="1"/>
                </clipPath>
            </defs>
            <g id="Group_337" data-name="Group 337" transform="translate(-1156 -658)">
                <g id="Mask_Group_133" data-name="Mask Group 133" clipPath="url(#clipPath)">
                    <g id="burger_group" transform="translate(1152.332 654.332)">
                        <path id="Path_357" data-name="Path 357" d="M5.042,8.709h19.25" transform="translate(0 -1)" fill="none" stroke="#1965a3" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="3"/>
                        <path id="Path_358" data-name="Path 358" d="M5.042,14.667h19.25" fill="none" stroke="#1965a3" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="3"/>
                        <path id="Path_359" data-name="Path 359" d="M5.042,20.625h19.25" transform="translate(0 1)" fill="none" stroke="#1965a3" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="3"/>
                    </g>
                </g>
            </g>
        </svg>
    );
}

function Caret(props){
	//const className = props.hasFocus ? "caret caret_up" : props.hasBeenToggled ? "caret caret_down" : "caret";
	return(
		<svg strokeWidth="5" className="side_panel_caret" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
			 viewBox="0 0 400 400" >
			<polygon className="side_panel_polygon" points="386.258,91.567 203.718,273.512 21.179,91.567 0,112.815 203.718,315.87 407.437,112.815 "/>
		</svg>
	);
}

SidePanel.propTypes = {
    title: PropTypes.string
};

export default SidePanel;